function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgRmb02(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#333",
    d: "M67.838 4.487h18.459L63.254 43.916h16.333v11.867H59.415v9.005h20.172v11.974H59.415v16.45H41.19v-16.45H20.318V64.788H41.19v-9.005H20.318V43.916h16.799L14.704 4.487h19.49c8.826 18.261 14.405 30.298 16.737 36.11h.404c.305-.843.664-1.892 1.085-3.157.691-2.018 3.444-7.983 8.252-17.885l7.166-15.068z"
  }));
}

SvgRmb02.clsName = 'icon-www__rmb-02';
SvgRmb02.remarkName = 'unknown';
export default SvgRmb02;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Rmb02.js
// module id = 2422
// module chunks = 17 18